/*
 * Created By sswaminathan
 * Created on Mon Nov 22 2021
 * Created on SubscriptionConstant.js
 * Copyright (c) 2021  ©Palo Alto Networks
 */

import {
  APP_ID_ADEM_AIOPS,
  APP_ID_AUTONOMOUS_DEM, APP_ID_COLO_CONNECT,
  APP_ID_CUSTOMER_SUCCESS,
  APP_ID_DATA_TRANSFER,
  APP_ID_DLP,
  APP_ID_DSS_ID,
  APP_ID_DVR,
  APP_ID_IOT,
  APP_ID_LOGGING_SERVICE,
  APP_ID_NET_INTER_CONNECT,
  APP_ID_NG_CASB,
  APP_ID_PRISMA_ACCESS,
  APP_ID_PRISMA_ACCESS_EDITION,
  APP_ID_PRISMA_ACCESS_MOBILE_USERS,
  APP_ID_PRISMA_ACCESS_ONPERM,
  APP_ID_PRISMA_ACCESS_PANORAMA, APP_ID_PRISMA_ACCESS_REMOTE_NETWORKS,
  APP_ID_PRISMA_SAAS,
  APP_ID_PRIVATE_APPS,
  APP_ID_PRIVATE_APPS_QTY,
  APP_ID_SDWAN,
  APP_ID_SERVICE_CONNECTION, APP_ID_SERVICE_LOC, APP_ID_TRAFFIC_MIRRORING
} from '../../../common/constants/GlobalConstants'
import { APP_ID_TO_UNIT_DESC } from '../../../common/constants/LabelConstants'
import { TOOLTIP_VIEW_CIE_ACTIVATION } from '../../../tenancy/constants/LabelConstants'

export const CONTRACT_LABEL = 'Please select contract to continue'
export const REGION_CAPS_LABEL = 'Region'
export const SELECT_REGION_LABEL = 'SASE REGION'

export const SELECT_REGION_DESC = 'The region where you deploy this tenant\'s products'
export const CHOOSE_LICENSE_LABEL = 'CHOOSE HOW TO ALLOCATE LICENSES'
export const PRISMA_ACCESS_LABEL = 'Prisma Access Enterprise'
export const PRISMA_SD_WAN = 'Prisma SD-WAN'
export const ALLOWED_LICENSE_CONTEXT = ['prisma_access', 'cgx', 'cdl', 'ng_casb']
export const ASSOCIATED_TENANTS = 'Associated Tenant'
export const TENANT_CONTRACT_INFO = 'Associated tenants to the contract:'
export const TENANTS = 'Tenants'

export const ALLOCATION_OPTION = [
  { value: 'false', children: 'Allocate part of this license to this tenant' },
  { value: 'true', children: 'Allocate the entire license to this tenant' }
]

export const LICENSE_LOAD_ERROR = 'Error Loading License. Please check again. '

export const CLAIM_ERROR_MSG = 'Claim failed. Please claim again. '
export const CLAIM_ERROR_TSG_MSG = 'Claim failed during TSG creation. Please check the access. '
export const RECLAIM_ERROR_MSG = 'ReClaim failed. Please claim again. '

export const ALLOCATE_LICENSE_LABEL = 'ALLOCATE LICENSES'
export const MOBILE_USERS_LABEL = 'Mobile Users'
export const MOBILE_USERS_LABEL_DESC = 'The number of users outside your tenant\'s physical location.'
export const REMOTE_USERS_LABEL_DESC = 'The remote network bandwidth speed your tenant needs.'
export const NUMBER_OF_USERS_LABEL = 'NUMBER OF USERS'

export const CDL_USER_LABEL = 'You can make this recommended minimum storage larger'
export const SERVICE_CONNECTION_USER_LABEL = 'Allow Prisma Access to access resources in your data center, headquarters, or remote networks.'
export const SERVICE_LOCATION_USER_LABEL = 'Please enter qty of Additional locations needed on this tenant in addition to the default that comes with the licenses'
export const NUMBER_OF_CONNECTIONS = 'NUMBER OF CONNECTIONS'
export const NUMBER_OF_LOCATIONS = 'NUMBER OF LOCATIONS'

export const REMOTE_NETWORK_LABEL = 'Remote Network'
export const REMOTE_NETWORK_LABEL_DESC = 'The remote network bandwidth speed your tenant needs'
export const BANDWIDTH_LABEL = 'BANDWIDTH (Mbps)'


export const ADDONS_LABEL = 'ADD-ONS'
export const BUNDLE_LABEL = 'BUNDLE PRODUCTS'
export const PLAN_SERVICE_LABEL = 'PLAN SERVICE CONNECTIONS'
export const PLAN_LOCATION_LABEL = 'ADDITIONAL LOCATION'
export const DIRECTORY_SYNC_HEADER = 'Additional Apps'

export const CDL_LABEL = 'SET UP CORTEX DATA LAKE'

export const ACCEPT_TERMS_CONDITIONS = 'Accept TermsAndConditions and Conditions'

export const CLAIMS_SUBSCRIPTION = 'Claims Subscriptions'
export const RECLAIMS_SUBSCRIPTION = 'Reclaim Subscriptions'
export const MODIFY_SUBSCRIPTION = 'Modify Subscriptions'
export const EVAL_TO_PROD_SUBSCRIPTION = 'Eval To Prod Request'
export const APPROVED_SUBSCRIPTION_LABEL = 'Approved Subscriptions'
export const CSP_ACCOUNT = 'Customer Support Account'

export const TEXTBOX_DESC_ALIGN = {
  BOTTOM: 'bottom',
  TOP: 'top',
  CENTER: 'center'
}
export const READY_FOR_ACTIVATION = 'READY FOR ACTIVATION'
export const ENTERPRISE = 'ENTERPRISE'
export const MSP = 'MSP'
export const ACTIVATION_FORK = 'ACTIVATION_FORK'
export const PANORAMA_SPLASH = 'PANORAMA_SPLASH'
export const USER_SINGLE_TENANT = 'USER_SINGLE_TENANT'

export const USER_FLOW = 'USER_FLOW'
export const USER_FLOW_MULTI = 'USER_FLOW_MULTI'
export const USER_FLOW_SINGLE = 'USER_FLOW_SINGLE'
export const TOGGLE_CLOUD_VIEW = 'Cloud Managed View'
export const TOGGLE_ST_VIEW = 'Single Tenant / Panorama View'

export const MAGIC_LINKED_CLAIMED = 'The activation link is already claimed or activated'
export const NO_CLAIMED_LICENSE = 'No Activated License'

export const ACTIVATE_TOOLTIP_NO_MSG = 'Click to Activate License'
export const CLAIM_BUTTON = 'Click to Claim License'
export const TOOLTIP_ST_BUTTON = 'Panorama Management or Single Tenant Cloud Management'
export const TOOLTIP_MT_BUTTON = `Multi-Tenant Cloud Managed supports multiple root tenants and child tenants. You can also share, split and assign licenses to various child tenants.
Panorama management is not supported in this mode.`
export const TOOLTIP_CLAIM_BUTTON = `Claim will enforce Cloud Management. If you wish to use Panorama, refresh the browser and select “Panorama / Single Tenant Cloud Managed”.
Claim license will associate the license with the tenant. Service instances are not activated after claim. Continue to activate the license on Tenant Management tab after claim.`
export const TOOLTIP_ACTIVATE_BUTTON = 'Activate will assign all license quantity to this tenant. If you wish to split or share the license, refresh the browser and select “Multi-Tenant Cloud Managed”.'
export const TOOLTIP_MODIFY_SUB_BUTTON = 'You will be able to request for amends, renewals by clicking on this button. '
export const TOOLTIP_UNCLAIM_BUTTON = 'If you have associated licenses with one tenant, you can remove the association and associate it with another tenant as long as licenses have not been activated on that tenant .'
export const CASB = 'casb'

export const SUBSCRIPTION_ERROR_MAPPING = {
  'SUB_SERVICE_1000': 'License Context Required',
  'SUB_SERVICE_1001': 'License Not Supported',
  'SUB_SERVICE_1002': 'Context Hash Required',
  'SUB_SERVICE_1003': 'License DB Write Failed',
  'SUB_SERVICE_1004': 'License Not Found in DB',
  'SUB_SERVICE_1005': 'Logging Service Auth Not Found',
  'SUB_SERVICE_1006': 'Invaild Schema',
  'SUB_SERVICE_1007': 'Activation Failed',
  'SUB_SERVICE_1008': 'License Already Claimed',
  'SUB_SERVICE_1009': 'License Id Required',
  'SUB_SERVICE_1010': 'License Payload Quota Not Valid',
  'SUB_SERVICE_1011': 'Tenancy Service Failure',
  'SUB_SERVICE_1012': 'Quota Is Locked',
  'SUB_SERVICE_1013': 'TSG Already Has Service Running',
  'SUB_SERVICE_1014': 'Failed To Claim Payload',
  'GENERIC_ERROR': 'Claim License Failed Due To Service Failure',
  'GENERIC_SUCCESS': 'License Successfully Claimed'
}
export const GENERIC_ERROR = 'GENERIC_ERROR'

export const SUCCESS_MESSAGE = 'Congratulations on claiming new licenses for $! Now you can set up licenses or add tenants from Tenant Management'

export const FIELD_REQUIRED = 'This is a mandatory field'

export const URL_VALIDATIONS = ['aperture', 'zingbox', 'ng_casb']
export const URL_VALIDATIONS_REGEX = {
  [APP_ID_IOT]: /^((?!-)[a-zA-Z0-9-]{0,63}[a-zA-Z0-9])$/,
  [APP_ID_PRISMA_SAAS]: /^((?!-)[a-zA-Z0-9-]{0,63}[a-zA-Z0-9])$/,
  [APP_ID_NG_CASB]: /^((?!-)[a-zA-Z0-9-]{0,63}[a-zA-Z0-9])$/
}
export const APP_ID_TO_MINVALUE = {
  [APP_ID_LOGGING_SERVICE]: 1,
  [APP_ID_PRISMA_ACCESS]: 100,
  [APP_ID_DSS_ID]: 200,
  [APP_ID_PRISMA_SAAS]: '',
  [APP_ID_PRISMA_ACCESS_EDITION]: 200,
  [APP_ID_NET_INTER_CONNECT]: 200,
  [APP_ID_PRIVATE_APPS]: 200,
  [APP_ID_PRIVATE_APPS_QTY]: 200,
  [APP_ID_DATA_TRANSFER]: 200,
  [APP_ID_DLP]: 0,
  [APP_ID_AUTONOMOUS_DEM]: 50,
  [APP_ID_IOT]: '',
  [APP_ID_CUSTOMER_SUCCESS]: 200,
  [APP_ID_PRISMA_ACCESS_ONPERM]: 200,
  [APP_ID_PRISMA_ACCESS_PANORAMA]: 200,
  [APP_ID_PRISMA_ACCESS_MOBILE_USERS]: 200,
  [APP_ID_SERVICE_CONNECTION]: 1,
  [APP_ID_SDWAN]: 200,
  [APP_ID_DVR]: 200,
  [APP_ID_ADEM_AIOPS]: 200
}

export const APP_ID_TO_INPUT_REQUIRED = {
  [APP_ID_LOGGING_SERVICE]: true,
  [APP_ID_PRISMA_ACCESS]: true,
  [APP_ID_DSS_ID]: false,
  [APP_ID_PRISMA_SAAS]: true,
  [APP_ID_PRISMA_ACCESS_EDITION]: true,
  [APP_ID_NET_INTER_CONNECT]: false,
  [APP_ID_PRIVATE_APPS]: false,
  [APP_ID_PRIVATE_APPS_QTY]: true,
  [APP_ID_DATA_TRANSFER]: false,
  [APP_ID_DLP]: false,
  [APP_ID_AUTONOMOUS_DEM]: true,
  [APP_ID_IOT]: true,
  [APP_ID_CUSTOMER_SUCCESS]: false,
  [APP_ID_PRISMA_ACCESS_ONPERM]: true,
  [APP_ID_PRISMA_ACCESS_PANORAMA]: true,
  [APP_ID_PRISMA_ACCESS_MOBILE_USERS]: true,
  [APP_ID_SERVICE_CONNECTION]: true,
  [APP_ID_SDWAN]: false,
  [APP_ID_DVR]: false,
  [APP_ID_SERVICE_LOC]: true,
  [APP_ID_ADEM_AIOPS]: true,
  [APP_ID_COLO_CONNECT]: true,
  [APP_ID_TRAFFIC_MIRRORING]: true
}

export const ALLOW_DISABLE_ADDONS = new Set([APP_ID_AUTONOMOUS_DEM, APP_ID_PRIVATE_APPS_QTY,
  APP_ID_SERVICE_LOC, APP_ID_ADEM_AIOPS, APP_ID_DSS_ID, APP_ID_TRAFFIC_MIRRORING, APP_ID_COLO_CONNECT])
export const QUANTITY_READONLY_ADDONS = new Set([APP_ID_PRIVATE_APPS, APP_ID_ADEM_AIOPS])
export const QUANTITY_CALCULATE_BY_BASE = new Set([APP_ID_ADEM_AIOPS, APP_ID_TRAFFIC_MIRRORING])
export const DUAL_NETWORKS_APP_IDS = new Set([APP_ID_ADEM_AIOPS, APP_ID_AUTONOMOUS_DEM])
export const USER_ACTION_REQUIRED = new Set([APP_ID_DSS_ID])

export const CALCULATED_FIELDS = ['dlp', 'net_interconct']
export const BLOCK_CLAIM_APPS = ['zingbox', 'aperture', 'dlp', 'okyo', 'pan_china']
export const ALLOCATION_ERROR_MSG = 'Something went wrong with Allocation Process. Please try again later'
export const MODIFY_SUBSCRIPTION_VALID_DATA = 'Please enter a valid input to modify subscription'
export const MODIFY_SUBSCRIPTION_SERVICE_ERROR = 'Error in modify subscription call'
export const SKU_SERVICE_LOCATION_WORLDWIDE = 'World wide'
export const SKU_SERVICE_LOCATION_LOCAL = 'Local'
export const ADEM_MOBILE_NETWORK_LABEL = 'Mobile Network Quantity'
export const ADEM_REMOTE_NETWORK_LABEL = 'Remote Network Quantity'

export const WORKFLOW_CLAIM_LICENSE = 'Claim Licenses'
export const WORKFLOW_CREATE_TENANT = 'Create Tenants'
export const WORKFLOW_ALLOCATE_LICENSE = 'Allocate Licenses'
export const WORKFLOW_NOTE_1 = 'Your subscription has been unclaimed.'
export const WORKFLOW_NOTE_2 = 'Please reclaim your license.'

export const UNCLAIM_SUBSCRIPTION_BUTTON_TEXT = 'Reclaim and continue'
export const MODIFY_SUBSCRIPTION_BUTTON_TEXT = 'Send Request'
export const CANCEL_BUTTON = 'Cancel'

export const TENANT_SELECTION_CSP_DESC = 'The account this license belongs to'
export const TENANT_SELECTION_TSG_DESC = 'The business that owns this license and can allocate it'

export const CLAIM_SUBSCRIPTION_BUTTON_TEXT = 'Claim and continue'
export const ACTION_BUTTON = 'Actions'
export const CLAIM = 'Claim'
export const UNCLAIM = 'UnClaim'
export const UPDATE = 'Update'
export const addNewTenantIdApps = ['dlp', 'logging_service', 'zingbox', 'aperture', 'cgx']
export const CLAIM_DISABLE_TOOLTIP = 'present as add-on and can not be used for cloud option. Please contact support!'
export const CLAIM_DISABLE_PAN_CHINA_TOOLTIP = 'present as part of license, Please use Single Tenant or Panorama flow to activate the license'
export const CLAIM_DISABLE_NO_LOGGING_SERVICE_TOOLTIP = 'Logging Service is not present in the license, please check with support'
export const CLAIM_TOOLTIP = 'Click to claim your License'
export const PARENTS_TENANT = 'Parent Tenant'
export const CDL_CALCULATOR = 'CDL Calculator'
export const CURRENT_TENANT = 'CURRENT'

export const SELECT_OR_CREATE = 'Select / Create New Tenant'
export const SELECT_TENANT = 'Select a Tenant'
export const SELECT_CSP = 'Select a CSP Account'
export const SELECT_CDL = 'Select a CDL'
export const SELECT_PANORAMA = 'Select Panorama S/N'
export const ADD_NEW = 'ADD_NEW'
export const CREATE_NEW = 'Create New'

export const SHARED = 'SHARED'
export const FULL = 'FULL'
export const VALIDATION_SUCCESS = 'Validation Success'
export const VALIDATION_FAILED = 'Validation Failed'

export const WELCOME_TEXT_1 = 'Welcome to Prisma Access'
export const WELCOME_TEXT_2 = 'Multitenant Cloud Management'
export const CONTINUE = 'Continue'
export const CLOUD_MANAGEMENT = 'Multi-Tenant Cloud Management'
export const PANORAMA_LINK = 'Panorama Managed / Single Tenant Cloud Management'
export const DISCLAIMER = 'Palo Alto Networks, Inc. All rights reserved.'
export const NOTE_SECTION = 'Sku:\nLicenseUnits:\nAdd-on:\nTerms:'

export const MODIFY_SUBSCRIPTION_SUCCESS = 'Modification request has been submitted'
export const EVAL_TO_PROD_SUBSCRIPTION_SUCCESS = 'Eval to Prod request has been submitted'


export const CDL_ALERT_HEADER = 'Allocate entire quota for Cortex Data Lake'
export const CDL_ALERT_CONTENT = 'You are about to allocate the  entire Quota for the Cortex Data Lake, which is shared between other licenses.'
export const VALIDATION_ALERT_CONTENT = 'Validation service failure occurred. Please try after sometime or contact support. ' +
  'Click on continue and navigate to tenant management page'
export const CONTINUE_BUTTON_TEXT = 'Continue'
export const VALIDATION_ALERT_HEADER = 'Validation Failure Alert'


export const LABEL_SELECT_ACTIVATION_FLOW = 'Select activation flow'

export const BUTTON_SIMPLE_SINGLE_TENANT = 'Single Tenant / Panorama'
export const BUTTON_MSP_AND_DISTRIBUTED_ENTERPRISE = 'MSP / Distributed Enterprise On Cloud Management'
export const BUTTON_NEED_HELP = 'Need Help?'
export const BUTTON_CONTACT_SUPPORT_LINK = 'Contact Support'
export const CONTACT_SUPPORT_URL = 'https://support.paloaltonetworks.com'
export const FULL_ALLOCATION = ['SINGLE', 'FULL']
export const SUBSCRIPTION_ACTION_EDIT = 'EDIT'

export const PRODUCT_LISTINGS = ['products', 'serviceConnection', 'serviceLocation', 'cdl', 'addOns', 'bundledApps', 'directorySync']
export const PRODUCT_PARAMETERS = {
  products: {
    header: ALLOCATE_LICENSE_LABEL,
    mobile: {
      textBoxHeader: NUMBER_OF_USERS_LABEL,
      appUserLabel: MOBILE_USERS_LABEL_DESC,
      appTextBoxDesc: APP_ID_TO_UNIT_DESC[APP_ID_PRISMA_ACCESS_MOBILE_USERS],
      labelOverRide: MOBILE_USERS_LABEL,
    },
    remote: {
      textBoxHeader: BANDWIDTH_LABEL,
      appUserLabel: REMOTE_USERS_LABEL_DESC,
      appTextBoxDesc: APP_ID_TO_UNIT_DESC[APP_ID_PRISMA_ACCESS_REMOTE_NETWORKS],
      labelOverRide: REMOTE_NETWORK_LABEL,
    }
  },
  directorySync: {
    header: DIRECTORY_SYNC_HEADER,
    textBoxHeader: NUMBER_OF_CONNECTIONS,
    appUserLabel: SERVICE_CONNECTION_USER_LABEL,
    //appTextBoxDesc: APP_ID_TO_UNIT_DESC[APP_ID_PRIVATE_APPS_QTY],
    indexKey: 'directorySync',
    showHeaderToolTip: true,
    toolTipContent: TOOLTIP_VIEW_CIE_ACTIVATION
  },
  serviceConnection: {
    header: PLAN_SERVICE_LABEL,
    textBoxHeader: NUMBER_OF_CONNECTIONS,
    appUserLabel: SERVICE_CONNECTION_USER_LABEL,
    //appTextBoxDesc: APP_ID_TO_UNIT_DESC[APP_ID_PRIVATE_APPS_QTY],
    indexKey: 'serviceConnection'
  },
  serviceLocation: {
    header: PLAN_LOCATION_LABEL,
    textBoxHeader: NUMBER_OF_LOCATIONS,
    appUserLabel: SERVICE_LOCATION_USER_LABEL,
    appTextBoxDesc: APP_ID_TO_UNIT_DESC[APP_ID_SERVICE_LOC],
    indexKey: 'serviceLocation'
  },
  cdl: {
    header: CDL_LABEL,
    appUserLabel: CDL_USER_LABEL,
    appTextBoxDesc: APP_ID_TO_UNIT_DESC[APP_ID_LOGGING_SERVICE],
    indexKey: 'cdl'
  },
  addOns: {
    header: ADDONS_LABEL,
    textBoxHeader: NUMBER_OF_CONNECTIONS,
    indexKey: 'addOns'
  }
}

export const EXCLUDE_REGION_HEADER = 'Exclude Regions'
export const RESET = 'Reset'
export const SAVE_BUTTON = 'Save'
export const PANORAMA_MULTI_CLOUD_USER_ALERT = 'The activation link you are accessing has Panorama managed license, Please choose single tenant flow for the using the panorama license'
export const BACKBONE_SECTION_HEADER = 'SP Backbone'
export const BACKBONE_LABEL_HEADER = 'SP Backbone'
export const BACKBONE_TOOLTIP_CONTENT = 'Select the backbone for egress traffic'
